var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 62,
    viewBox: "0 0 69 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0006 30.1383C20.6744 32.1327 19.8154 34.0072 18.5106 35.5717C19.0056 35.5717 17.5356 36.952 35.5504 17.8326L15.0007 2.17871V22.6198C20.0406 27.5538 21.2556 28.2293 21.0006 30.1383ZM37.9504 19.6535L22.9356 35.5717H61.0651L46.0653 19.6535C41.3403 23.2512 42.6753 23.2512 37.9504 19.6535Z",
    fill: "#DCDADD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.555 0.328125H17.4457L42.0004 19.0217L66.555 0.328125Z",
    fill: "#DCDADD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4503 17.8326L65.16 35.5717H69V2.17871L48.4503 17.8326Z",
    fill: "#DCDADD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5006 53.1937C21.6914 51.8807 18.2317 49.7478 15.3762 46.9523C12.5206 44.1567 10.342 40.7697 9.00076 37.0406C11.1492 37.07 13.2375 36.3459 14.8881 34.9993C16.5387 33.6526 17.6428 31.7723 18.0006 29.6982L7.50078 19.4189C5.38217 19.7693 3.4615 20.8502 2.08598 22.4661C0.710463 24.0821 -0.0291378 26.1265 0.000879036 28.2298C0.000879036 37.1874 3.63564 45.7781 10.1056 52.1121C16.5755 58.4461 25.3506 62.0045 34.5004 62.0045C36.6489 62.0339 38.7371 61.3099 40.3878 59.9632C42.0384 58.6166 43.1424 56.7363 43.5003 54.6622L33.0005 44.3829C30.8818 44.7333 28.9612 45.8141 27.5857 47.4301C26.2101 49.046 25.4705 51.0904 25.5006 53.1937Z",
    fill: "#F7B01A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact_icon.675293eb2fb6cc0576744c335211397a.svg";
export { ForwardRef as ReactComponent };